import * as navStyles from "../../styles/layout/transversal-nav-nojs.module.scss";

import React, {Fragment, useEffect} from "react";

import IconContainer from "../shared/IconContainer";
import PolyLink from "../shared/PolyLink";
import {capitalize} from "lodash";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {handleMenuMouseLeave} from "../../services/menuEventUtils";

const NestedItem = React.memo(function NestedItem({menu, maref}) {
    const {t} = useTranslation();

    const [idFocus, setIdFocus] = React.useState(null);

    useEffect(() => {
        for (const child of maref.current.children) {
            child.classList.remove(navStyles.nojs);
        }
    }, [maref]);

    const [openMenu, setOpenMenu] = React.useState(false);

    let mouseTarget = null;

    let addOnClickEvent = () => {
        return null;
    };

    const resetStyles = () => {
        mouseTarget.classList.remove(navStyles.js);
    };

    if (typeof window !== `undefined`) {
        addOnClickEvent = (id) => {
            mouseTarget = document.getElementById(id);
            handleMenuMouseLeave("navigationTransversal", resetStyles);
            for (const child of maref.current.children) {
                if (child.id === id) {
                    child.classList.toggle(navStyles.js);
                } else {
                    child.classList.remove(navStyles.js);
                }
            }
        };
    }


    // let addClickonKeyPress = () => {
    //     return null
    // };
    let addClickonKeyUp = () => {
        return null
    };

    // if (typeof window !== `undefined`) {
    //     addClickonKeyPress = (event, id) => {
    //         event.preventDefault();
    //         const target = document.getElementById(id);
    //         if (event.key === "Enter" || event.code === "Space") {
    //             if (target.children.length === 1) {
    //                 target.addEventListener("focusout", () => target.click())
    //             }
    //             target.click()
    //         }
    //     };
    // }

    if (typeof window !== `undefined`) {
        addClickonKeyUp = (event, id) => {
            event.preventDefault();
            const target = document.getElementById(id);
            if (target.lastChild.contains(document.activeElement)) {
            }

            if (event.key === "Tab") {
                if (target.children.length === 1) {
                    target.addEventListener("focusout", () => target.click())
                }
                if (!openMenu) {
                    target.click()
                    setIdFocus(id)
                    setOpenMenu(true)
                }
                if (id !== idFocus && idFocus !== null) {
                    target.click()
                    setIdFocus(id)
                    setOpenMenu(true)
                }
            }
        };
    }

    return (<Fragment>
        {menu.map((item, currentIndex) => {
            if (item.subMenuItems?.length > 0) {
                return (
                    <button id={"NestedItem" + currentIndex} tabIndex={0}
                        className={clsx(navStyles.dropdown__category, navStyles.menu__item, navStyles.nojs)}
                        key={currentIndex}
                        onClick={() => addOnClickEvent("NestedItem" + currentIndex)}
                        onKeyUp={(event) => addClickonKeyUp(event, "NestedItem" + currentIndex)}
                    >
                        <div className={navStyles.nested__menu__title}>
                            <PolyLink
                                url={item.url}
                                target="_blank"
                                id={`sub-menu-item-${currentIndex}}`}
                                style={{color: "inherit"}}
                                notFocus={true}
                            >
                                {t(item.title.toUpperCase())}
                            </PolyLink>
                            <IconContainer
                                icon="ARROW_DOWN_SMALL"
                                color="WHITE"
                                size={25}
                                tabindex={-1}
                                notFocus={true}
                            />
                        </div>
                        <ul
                            className={clsx(navStyles.dropdown__menu, navStyles.nested__sub__menu)}
                        >
                            {item.subMenuItems?.map((subItem, subCurrentIndex, subArray) => {
                                return (
                                    <li
                                        key={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                                        aria-controls={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                                        data-title={capitalize(subItem.title)}
                                    >
                                        <PolyLink
                                            url={subItem.url || "#"}
                                            target="_blank"
                                            id={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                                            tabIndex="0"
                                            className={navStyles.sub__menu__title}
                                        >
                                            {capitalize(subItem.title)}
                                        </PolyLink>
                                        {subCurrentIndex !== subArray.length - 1 && (
                                            <div className={navStyles.line__divider}/>)}
                                    </li>
                                );
                            })}
                        </ul>
                    </button>
                )
            } else {
                return (
                    <button id={"NestedItem" + currentIndex} tabIndex={-1}
                        className={clsx(navStyles.dropdown__category, navStyles.menu__item, navStyles.nojs)}
                        key={currentIndex}
                        onClick={() => addOnClickEvent("NestedItem" + currentIndex)}
                        onKeyUp={(event) => addClickonKeyUp(event, "NestedItem" + currentIndex)}
                    >
                        <PolyLink
                            className={navStyles.nested__menu__title}
                            url={item.url || "#"}
                            target="_blank"
                            id={`sub-menu-item-${currentIndex}}`}
                        >
                            {t(item.title.toUpperCase())}
                        </PolyLink>
                    </button>
                )
            }
        })}
    </Fragment>);
});

export default NestedItem;
